const CloseSideMenuIcon = ({ height = "40px", width = "40px" }: { height?: string; width?: string }) => {

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: `${width}`, height: `${height}` }} // Use inline styles here
      viewBox="0 0 40 40"
      fill="none"
    >
      <g clipPath="url(#clip0_589_11461)" filter="url(#filter0_d_589_11461)">
        <path
          d="M20 36C28.8227 36 36 28.8227 36 20C36 11.1773 28.8227 4 20 4C11.1773 4 4 11.1773 4 20C4 28.8227 11.1773 36 20 36ZM15.0573 19.0573L21.724 12.3907C21.984 12.1307 22.3253 12 22.6667 12C23.008 12 23.3494 12.1307 23.6094 12.3907C24.1307 12.912 24.1307 13.7547 23.6094 14.276L17.8853 20L23.6093 25.724C24.1306 26.2453 24.1306 27.088 23.6093 27.6093C23.088 28.1306 22.2453 28.1306 21.724 27.6093L15.0573 20.9426C14.536 20.4213 14.536 19.5787 15.0573 19.0573Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_589_11461"
          x="0"
          y="0"
          width="40"
          height="40"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_589_11461"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_589_11461"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_589_11461">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(36 36) rotate(180)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CloseSideMenuIcon;
